import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import WhoWeAre from '../components/WhoWeAre';
import CompanyStats from '../components/companyStats';
import TeamSection from '../components/teammember';
import TrustedBy from '../components/trustBy';
import { FiCheckSquare } from 'react-icons/fi';

const About = () => {
  const { t } = useTranslation();

  const bioParagraphs = [
    t('aboutUsParagraph1'),
    t('aboutUsParagraph2'),
    t('aboutUsParagraph3'),
    t('aboutUsParagraph4')
  ];

  return (
    <div className="bg-white dark:bg-[#080808] text-slate-800 dark:text-slate-100 transition-colors duration-500 min-h-screen">
      
      {/* 1. Header Banner */}
      <section className="relative py-24 bg-slate-50 dark:bg-[#0c0c0e] border-b border-slate-200/50 dark:border-neutral-900/60 overflow-hidden pt-36">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:14px_24px] opacity-40" />
        <div className="absolute top-10 left-1/4 w-72 h-72 rounded-full bg-blue-500/5 dark:bg-purple-500/5 blur-3xl" />
        
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 text-center">
          <span className="text-xs font-bold text-blue-600 dark:text-purple-400 uppercase tracking-widest">
            {t('aboutLabel', 'Journey')}
          </span>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-900 dark:text-white mt-2">
            {t('about_us')}
          </h1>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-purple-500 dark:to-pink-500 mx-auto mt-4 rounded-full" />
        </div>
      </section>

      {/* 2. Detailed Company Bio */}
      <section className="py-20 relative">
        <div className="max-w-4xl mx-auto px-6 flex flex-col gap-8">
          {bioParagraphs.map((paragraph, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              className="flex gap-4 items-start p-6 rounded-3xl bg-slate-50/50 dark:bg-[#111111]/20 border border-slate-100 dark:border-neutral-800/40 shadow-sm"
            >
              <div className="p-2 rounded-xl bg-blue-500/10 text-blue-600 dark:text-purple-400 mt-1 flex-shrink-0">
                <FiCheckSquare className="w-5 h-5" />
              </div>
              <p className="text-sm sm:text-base text-slate-600 dark:text-slate-300 leading-relaxed font-medium">
                {paragraph}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 3. Who We Are Panel */}
      <WhoWeAre />

      {/* 4. Numbers */}
      <CompanyStats />

      {/* 5. Team Leaders */}
      {/* <TeamSection /> */}

      {/* 6. Clients */}
      <TrustedBy />

    </div>
  );
};

export default About;